import { getInnLadderRank } from 'dt-common/isomorphic-helpers/getInnLadderRank';
import { findHeroBuildById } from '~/helpers/findHeroBuildById';
import CavernsStore from './CavernsStore/CavernsStore';
import GameStateStore from './GameStateStore/GameStateStore';
import HeroBuildStore from './HeroBuildStore/HeroBuildStore';
import InnStore from './InnStore/InnStore';
import PlayerStore from './PlayerStore';
import UIStore from './UIStore';

const getFocusedHeroBuild = () => {
  const { hero_handle, build_id } = UIStore.getAll().focused_hero_build;
  const { hero_builds } = HeroBuildStore.getAll();
  return {
    built_hero: findHeroBuildById(hero_builds[hero_handle], build_id),
    hero_handle,
    roster_hero: GameStateStore.getAll().gameState.hero_roster[hero_handle],
  };
};

const getFocusedHero = () => {
  return getHeroByHandle(UIStore.getAll().focused_hero_handle);
};

const getHeroByHandle = (hero_handle) => {
  const { current_game_mode, current_game_submode } = UIStore.getAll();
  const { hero_roster, loadouts } = GameStateStore.getAll().gameState;
  return {
    built_hero: getFocusedHeroBuild().built_hero,
    loadout_hero: loadouts[current_game_mode][current_game_submode].find(
      ({ handle }) => handle === hero_handle
    ),
    roster_hero: hero_roster[hero_handle],
  };
};

const getRemainingCavernsRunInventorySpace = () =>
  GameStateStore.getGlobalInventorySpaceRemaining() -
  (CavernsStore.getAll().itemsPickedUp || []).length;

/**
 * Logged-in player's row in the active inn tournament for the focused UI submode,
 * plus 1-based ladder position from `getInnLadderRank` as `tourney_rank`.
 * Uses `current_tourney_instance` from InnStore (must match `UIStore.current_game_submode`).
 */
const getFocusedTournamentState = () => {
  const { loggedInPlayerId } = PlayerStore.getAll();
  const { current_game_submode } = UIStore.getAll();
  const { current_tourney_instance } = InnStore.getAll();

  if (!loggedInPlayerId || !current_tourney_instance?.players?.length) {
    return null;
  }

  if (
    current_game_submode &&
    current_tourney_instance.game_submode &&
    current_tourney_instance.game_submode !== current_game_submode
  ) {
    return null;
  }

  const players = current_tourney_instance.players;
  const playersForRank = players.map((p) => ({
    playerId: p.playerId ?? p._id,
  }));
  const playerEntry = players.find(
    (p) => p.playerId === loggedInPlayerId || p._id === loggedInPlayerId
  );
  const tourney_rank = getInnLadderRank(playersForRank, loggedInPlayerId);

  if (!playerEntry) {
    return null;
  }

  return {
    ...playerEntry,
    tourney_rank,
  };
};

export default {
  getFocusedHeroBuild,
  getFocusedHero,
  getHeroByHandle,
  getFocusedTournamentState,
  getRemainingCavernsRunInventorySpace,
};
